// StockMaestro Accounts Module v3.0 — Build 3
(function(){
  'use strict';
  const db=()=>window.SM.DB, ui=()=>window.SM.UI, util=()=>window.SM.UTIL;

  function initTabs(){
    const tabs=document.getElementById('ims-acc-tabs');
    if(!tabs)return;
    tabs.querySelectorAll('.ims__tab').forEach(tab=>{
      tab.addEventListener('click',()=>{
        tabs.querySelectorAll('.ims__tab').forEach(t=>t.classList.remove('ims__tab--active'));
        tab.classList.add('ims__tab--active');
        loadTab(tab.dataset.tab);
      });
    });
  }

  function loadTab(tab){
    switch(tab){
      case 'overview':      loadOverview();     break;
      case 'invoices':      loadInvoices();     break;
      case 'notes':         loadNotes();        break;
      case 'payables':      loadPayables();     break;
      case 'receivables':   loadReceivables();  break;
      case 'transactions':  loadTransactions(); break;
      case 'claims':        loadClaims();       break;
      case 'vat':           loadVAT();          break;
    }
  }

  // ─── OVERVIEW (P&L) ─────────────────────────────────────────────
  async function loadOverview(){
    const content=document.getElementById('ims-acc-content');
    if(!content)return;
    content.innerHTML=`<div class="ims__loading"><i class="ti ti-loader-2 ims__spin"></i></div>`;
    const now=new Date();
    const mStart=new Date(now.getFullYear(),now.getMonth(),1).toISOString().split('T')[0];
    const mEnd=new Date(now.getFullYear(),now.getMonth()+1,0).toISOString().split('T')[0];
    const yStart=`${now.getFullYear()}-01-01`;
    const yEnd=`${now.getFullYear()}-12-31`;
    const [{data:txMonth},{data:txYear},{data:payables},{data:receivables},{data:claims},{data:invStats}]=await Promise.all([
      db().select('transactions',{gte:{date:mStart},lte:{date:mEnd}}),
      db().select('transactions',{gte:{date:yStart},lte:{date:yEnd}}),
      db().select('accounts_payable',{neq:{status:'paid'}}),
      db().select('accounts_receivable',{neq:{status:'paid'}}),
      db().select('claims',{in:{status:['raised','acknowledged','escalated_14','overdue_30']}}),
      db().select('invoices',{in:{status:['draft','sent','overdue']}})
    ]);
    const calc=(txs,type,category=null)=>(txs||[]).filter(t=>t.type===type&&(!category||t.category===category)).reduce((s,t)=>s+(t.amount||0),0);
    const mRevenue=calc(txMonth,'income');
    const mCOGS=calc(txMonth,'expense','Cost of goods sold');
    const mExpenses=(txMonth||[]).filter(t=>t.type==='expense'&&t.category!=='Cost of goods sold').reduce((s,t)=>s+(t.amount||0),0);
    const mGrossProfit=mRevenue-mCOGS;
    const mNetProfit=mGrossProfit-mExpenses;
    const yRevenue=calc(txYear,'income');
    const yCOGS=calc(txYear,'expense','Cost of goods sold');
    const yExpenses=(txYear||[]).filter(t=>t.type==='expense'&&t.category!=='Cost of goods sold').reduce((s,t)=>s+(t.amount||0),0);
    const yGrossProfit=yRevenue-yCOGS;
    const yNetProfit=yGrossProfit-yExpenses;
    const totalPayables=(payables||[]).reduce((s,p)=>s+((p.amount||0)-(p.paid_amount||0)),0);
    const totalReceivables=(receivables||[]).reduce((s,r)=>s+((r.amount||0)-(r.paid_amount||0)),0);
    const openInvoices=(invStats||[]);
    const invoiceTotal=openInvoices.reduce((s,i)=>s+(i.gross_amount||0),0);
    const overdueInvoices=openInvoices.filter(i=>i.status==='overdue').length;
    content.innerHTML=`
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:16px">
        <div class="ims__card">
          <div class="ims__card-header"><div class="ims__card-title"><i class="ti ti-chart-bar"></i>This month — P&amp;L</div></div>
          <table class="ims__table"><tbody>
            <tr><td>Sales revenue</td><td style="text-align:right;font-weight:600;color:var(--ims-success)">${util().formatCurrency(mRevenue)}</td></tr>
            <tr><td style="padding-left:20px;color:var(--ims-text-sec)">Less: Cost of goods sold</td><td style="text-align:right;color:var(--ims-text-sec)">(${util().formatCurrency(mCOGS)})</td></tr>
            <tr style="border-top:2px solid var(--ims-border)"><td><strong>Gross profit</strong></td><td style="text-align:right;font-weight:700;color:${mGrossProfit>=0?'var(--ims-success)':'var(--ims-danger)'}">${util().formatCurrency(mGrossProfit)}</td></tr>
            <tr><td style="padding-left:20px;color:var(--ims-text-sec)">Less: Operating expenses</td><td style="text-align:right;color:var(--ims-text-sec)">(${util().formatCurrency(mExpenses)})</td></tr>
            <tr style="border-top:2px solid var(--ims-border);font-size:15px"><td><strong>Net profit</strong></td><td style="text-align:right;font-weight:700;color:${mNetProfit>=0?'var(--ims-success)':'var(--ims-danger)'}">${util().formatCurrency(mNetProfit)}</td></tr>
          </tbody></table>
        </div>
        <div class="ims__card">
          <div class="ims__card-header"><div class="ims__card-title"><i class="ti ti-chart-bar"></i>This year — P&amp;L</div></div>
          <table class="ims__table"><tbody>
            <tr><td>Sales revenue</td><td style="text-align:right;font-weight:600;color:var(--ims-success)">${util().formatCurrency(yRevenue)}</td></tr>
            <tr><td style="padding-left:20px;color:var(--ims-text-sec)">Less: Cost of goods sold</td><td style="text-align:right;color:var(--ims-text-sec)">(${util().formatCurrency(yCOGS)})</td></tr>
            <tr style="border-top:2px solid var(--ims-border)"><td><strong>Gross profit</strong></td><td style="text-align:right;font-weight:700;color:${yGrossProfit>=0?'var(--ims-success)':'var(--ims-danger)'}">${util().formatCurrency(yGrossProfit)}</td></tr>
            <tr><td style="padding-left:20px;color:var(--ims-text-sec)">Less: Operating expenses</td><td style="text-align:right;color:var(--ims-text-sec)">(${util().formatCurrency(yExpenses)})</td></tr>
            <tr style="border-top:2px solid var(--ims-border);font-size:15px"><td><strong>Net profit</strong></td><td style="text-align:right;font-weight:700;color:${yNetProfit>=0?'var(--ims-success)':'var(--ims-danger)'}">${util().formatCurrency(yNetProfit)}</td></tr>
          </tbody></table>
        </div>
      </div>
      <div style="display:grid;grid-template-columns:repeat(5,1fr);gap:12px;margin-bottom:16px">
        <div class="ims__stat" style="cursor:pointer" onclick="window.IMS_ACCOUNTS.switchTab('invoices')">
          <div class="ims__stat-label">Open invoices</div>
          <div class="ims__stat-value ims__stat-value--accent" style="font-size:18px">${util().formatCurrency(invoiceTotal)}</div>
          ${overdueInvoices>0?`<div class="ims__stat-sub" style="color:var(--ims-danger)">${overdueInvoices} overdue</div>`:''}
        </div>
        <div class="ims__stat" style="cursor:pointer" onclick="window.IMS_ACCOUNTS.switchTab('payables')"><div class="ims__stat-label">Payables outstanding</div><div class="ims__stat-value ims__stat-value--${totalPayables>0?'warning':''}" style="font-size:18px">${util().formatCurrency(totalPayables)}</div></div>
        <div class="ims__stat" style="cursor:pointer" onclick="window.IMS_ACCOUNTS.switchTab('receivables')"><div class="ims__stat-label">Receivables outstanding</div><div class="ims__stat-value ims__stat-value--${totalReceivables>0?'accent':''}" style="font-size:18px">${util().formatCurrency(totalReceivables)}</div></div>
        <div class="ims__stat" style="cursor:pointer" onclick="window.IMS_ACCOUNTS.switchTab('claims')"><div class="ims__stat-label">Open claims</div><div class="ims__stat-value ims__stat-value--${(claims||[]).length>0?'warning':''}" style="font-size:18px">${(claims||[]).length}</div></div>
        <div class="ims__stat"><div class="ims__stat-label">Expense categories</div><div class="ims__stat-value" style="font-size:14px">${[...new Set((txMonth||[]).filter(t=>t.type==='expense').map(t=>t.category))].length}</div></div>
      </div>
      ${mExpenses>0?`
        <div class="ims__card">
          <div class="ims__card-header"><div class="ims__card-title"><i class="ti ti-chart-pie"></i>This month — expenses by category</div></div>
          <div class="ims__table-wrap"><table class="ims__table">
            <thead><tr><th>Category</th><th style="text-align:right">Amount</th><th style="text-align:right">% of total</th></tr></thead>
            <tbody>${Object.entries((txMonth||[]).filter(t=>t.type==='expense').reduce((acc,t)=>{acc[t.category]=(acc[t.category]||0)+(t.amount||0);return acc;},{})).sort((a,b)=>b[1]-a[1]).map(([cat,amt])=>`
              <tr><td>${util().sanitize(cat)}</td><td style="text-align:right">${util().formatCurrency(amt)}</td><td style="text-align:right">${mExpenses>0?((amt/mExpenses)*100).toFixed(1)+'%':'—'}</td></tr>`).join('')}
            </tbody>
          </table></div>
        </div>` : ''}`;
  }

  function switchTab(tab){
    const tabs=document.getElementById('ims-acc-tabs');
    tabs?.querySelectorAll('.ims__tab').forEach(t=>{t.classList.toggle('ims__tab--active',t.dataset.tab===tab);});
    loadTab(tab);
  }

  // ─── ADD TRANSACTION ─────────────────────────────────────────────
  function showNewTransaction(){
    const categories={
      income:['Sales revenue','Other income'],
      expense:['Salaries & wages','Rent & property','Fuel & vehicle','Utilities','Courier charges','Import duties & freight','Marketing & advertising','Insurance','Equipment & maintenance','Cost of goods sold','Miscellaneous']
    };
    ui().openModal('Add transaction',`
      <div class="ims__form-grid">
        <div class="ims__form-group"><label class="ims__label ims__label--req">Date</label><input class="ims__input" type="date" id="ims-tx-date" value="${new Date().toISOString().split('T')[0]}"></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Type</label>
          <select class="ims__select" id="ims-tx-type" onchange="window.IMS_ACCOUNTS.onTxTypeChange()"><option value="income">Income</option><option value="expense">Expense</option></select></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Category</label>
          <select class="ims__select" id="ims-tx-category">${categories.income.map(c=>`<option value="${c}">${c}</option>`).join('')}</select></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Amount (£)</label><input class="ims__input" type="number" step="0.01" min="0" id="ims-tx-amount"></div>
        <div class="ims__form-group"><label class="ims__label">VAT amount (£)</label><input class="ims__input" type="number" step="0.01" min="0" id="ims-tx-vat" placeholder="0.00"></div>
        <div class="ims__form-group"><label class="ims__label">Reference</label><input class="ims__input" type="text" id="ims-tx-ref" placeholder="Invoice #, PO #, receipt..."></div>
        <div class="ims__form-group ims__form-group--full"><label class="ims__label">Description</label><textarea class="ims__textarea" id="ims-tx-desc" rows="2"></textarea></div>
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_ACCOUNTS.saveTransaction()"><i class="ti ti-check"></i> Save</button>
    `,'sm');
  }

  function onTxTypeChange(){
    const type=document.getElementById('ims-tx-type')?.value;
    const catSel=document.getElementById('ims-tx-category');
    if(!catSel)return;
    const cats={income:['Sales revenue','Other income'],expense:['Salaries & wages','Rent & property','Fuel & vehicle','Utilities','Courier charges','Import duties & freight','Marketing & advertising','Insurance','Equipment & maintenance','Cost of goods sold','Miscellaneous']};
    catSel.innerHTML=(cats[type]||cats.income).map(c=>`<option value="${c}">${c}</option>`).join('');
  }

  async function saveTransaction(){
    const g=id=>document.getElementById(id)?.value?.trim()||'';
    const date=g('ims-tx-date'),type=g('ims-tx-type'),category=g('ims-tx-category'),amount=parseFloat(g('ims-tx-amount'));
    if(!date){ui().toast('Date is required','error');return;}
    if(!category){ui().toast('Category is required','error');return;}
    if(isNaN(amount)||amount<=0){ui().toast('Please enter a valid amount','error');return;}
    const {error}=await db().insert('transactions',{date,type,category,amount,vat_amount:parseFloat(g('ims-tx-vat'))||0,reference:g('ims-tx-ref')||null,description:g('ims-tx-desc')||null,user_id:window.SM.AUTH.user?.id});
    if(error){ui().toast('Failed: '+error.message,'error');return;}
    ui().closeModal();ui().toast('Transaction saved','success');loadOverview();
  }

  // ─── INVOICES TAB ────────────────────────────────────────────────
  async function loadInvoices(){
    const content=document.getElementById('ims-acc-content');
    if(!content)return;
    content.innerHTML=`<div class="ims__loading"><i class="ti ti-loader-2 ims__spin"></i></div>`;

    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    const {data:invoices}=await client.from('invoices')
      .select('*')
      .eq('company_id',window.SM.AUTH.company?.id)
      .eq('invoice_type','sales')
      .order('created_at',{ascending:false})
      .limit(100);

    const items=invoices||[];
    const totalDraft=items.filter(i=>i.status==='draft').reduce((s,i)=>s+(i.gross_amount||0),0);
    const totalSent=items.filter(i=>i.status==='sent').reduce((s,i)=>s+(i.gross_amount||0),0);
    const totalOverdue=items.filter(i=>i.status==='overdue').reduce((s,i)=>s+(i.gross_amount||0),0);
    const totalPaid=items.filter(i=>i.status==='paid').reduce((s,i)=>s+(i.gross_amount||0),0);

    content.innerHTML=`
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px;flex-wrap:wrap;gap:8px">
        <div style="display:flex;gap:10px;flex-wrap:wrap">
          <div class="ims__stat" style="padding:8px 14px;min-width:100px"><div class="ims__stat-label">Draft</div><div class="ims__stat-value" style="font-size:15px">${util().formatCurrency(totalDraft)}</div></div>
          <div class="ims__stat" style="padding:8px 14px;min-width:100px"><div class="ims__stat-label">Sent / awaiting</div><div class="ims__stat-value ims__stat-value--accent" style="font-size:15px">${util().formatCurrency(totalSent)}</div></div>
          <div class="ims__stat" style="padding:8px 14px;min-width:100px"><div class="ims__stat-label">Overdue</div><div class="ims__stat-value ims__stat-value--danger" style="font-size:15px">${util().formatCurrency(totalOverdue)}</div></div>
          <div class="ims__stat" style="padding:8px 14px;min-width:100px"><div class="ims__stat-label">Paid</div><div class="ims__stat-value ims__stat-value--success" style="font-size:15px">${util().formatCurrency(totalPaid)}</div></div>
        </div>
        <div class="ims__btn-group">
          <button class="ims__btn ims__btn--secondary" onclick="window.IMS_ACCOUNTS.showExport()"><i class="ti ti-download"></i> Export</button>
          <button class="ims__btn ims__btn--secondary" onclick="window.IMS_ACCOUNTS.showGenerateFromOrder()"><i class="ti ti-file-plus"></i> From order</button>
          <button class="ims__btn ims__btn--primary" onclick="window.IMS_ACCOUNTS.showNewInvoice()"><i class="ti ti-plus"></i> New invoice</button>
        </div>
      </div>
      <div class="ims__card">
        <div class="ims__table-wrap">
          <table class="ims__table">
            <thead><tr><th>Invoice #</th><th>Customer</th><th>Date</th><th>Due date</th><th>Net</th><th>VAT</th><th>Gross</th><th>Status</th><th></th></tr></thead>
            <tbody>${items.map(inv=>`<tr>
              <td><span class="ims__link" onclick="window.IMS_ACCOUNTS.openInvoice('${inv.id}')">${util().sanitize(inv.invoice_number)}</span></td>
              <td>${util().sanitize(inv.customer_name||'—')}</td>
              <td style="font-size:11px">${util().formatDate(inv.invoice_date)}</td>
              <td style="font-size:11px;color:${inv.status==='overdue'?'var(--ims-danger)':''}">${util().formatDate(inv.due_date)}</td>
              <td>${util().formatCurrency(inv.net_amount)}</td>
              <td style="font-size:11px">${util().formatCurrency(inv.vat_amount)}</td>
              <td style="font-weight:600">${util().formatCurrency(inv.gross_amount)}</td>
              <td>${util().pill(inv.status)}</td>
              <td><div class="ims__btn-group">
                <button class="ims__btn ims__btn--secondary ims__btn--sm ims__btn--icon" onclick="window.IMS_ACCOUNTS.openInvoice('${inv.id}')" title="View"><i class="ti ti-eye"></i></button>
                <button class="ims__btn ims__btn--secondary ims__btn--sm ims__btn--icon" onclick="window.IMS_ACCOUNTS.printInvoice('${inv.id}')" title="Print"><i class="ti ti-printer"></i></button>
                ${inv.status==='draft'?`<button class="ims__btn ims__btn--info ims__btn--sm ims__btn--icon" onclick="window.IMS_ACCOUNTS.markInvoiceSent('${inv.id}')" title="Mark sent"><i class="ti ti-send"></i></button>`:''}
                ${['sent','overdue'].includes(inv.status)?`<button class="ims__btn ims__btn--success ims__btn--sm ims__btn--icon" onclick="window.IMS_ACCOUNTS.markInvoicePaid('${inv.id}',${inv.gross_amount})" title="Mark paid"><i class="ti ti-currency-pound"></i></button>`:''}
                ${['sent','overdue','paid'].includes(inv.status)?`<button class="ims__btn ims__btn--warning ims__btn--sm ims__btn--icon" onclick="window.IMS_ACCOUNTS.showNewNote('${inv.id}','${util().sanitize(inv.invoice_number)}')" title="Issue credit/debit note"><i class="ti ti-file-minus"></i></button>`:''}
                ${window.SM.AUTH.isSuperAdmin()?`<button class="ims__btn ims__btn--danger ims__btn--sm ims__btn--icon" onclick="window.IMS_ACCOUNTS.deleteInvoice('${inv.id}','${util().sanitize(inv.invoice_number)}')" title="Delete invoice (Super Admin only)"><i class="ti ti-trash"></i></button>`:''}
              </div></td>
            </tr>`).join('')||'<tr><td colspan="9" class="ims__table-empty">No invoices yet — create one from an order or manually</td></tr>'}
            </tbody>
          </table>
        </div>
      </div>`;
  }

  async function showNewInvoice(){
    const company=window.SM.AUTH.company;
    const vatRate=company?.default_vat_rate||20;
    const payDays=company?.default_payment_days||14;
    const today=new Date().toISOString().split('T')[0];
    const due=new Date(Date.now()+payDays*86400000).toISOString().split('T')[0];
    const prefix=company?.invoice_prefix||'INV';

    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    const {data:lastInv}=await client.from('invoices').select('invoice_number').eq('company_id',company?.id).eq('invoice_type','sales').order('created_at',{ascending:false}).limit(1).maybeSingle();
    const nextNum=util().generateRef(prefix,lastInv?.invoice_number);

    const {data:codes}=await client.from('account_codes').select('id,display_name,xero_code,sage50_code').eq('company_id',company?.id).eq('is_income',true).order('sort_order');
    const codeOpts=(codes||[]).map(c=>`<option value="${c.id}">${util().sanitize(c.display_name)}</option>`).join('');

    ui().openModal('New sales invoice',`
      <div class="ims__form-grid">
        <div class="ims__form-group"><label class="ims__label">Invoice number</label><input class="ims__input" type="text" id="ims-inv-num" value="${nextNum}" readonly style="background:var(--ims-surface2)"></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Customer name</label><input class="ims__input" type="text" id="ims-inv-cust"></div>
        <div class="ims__form-group"><label class="ims__label">Customer email</label><input class="ims__input" type="email" id="ims-inv-email"></div>
        <div class="ims__form-group"><label class="ims__label">Customer VAT number</label><input class="ims__input" type="text" id="ims-inv-cvat" placeholder="GB123456789"></div>
        <div class="ims__form-group ims__form-group--full"><label class="ims__label">Customer address</label><textarea class="ims__textarea" id="ims-inv-addr" rows="2"></textarea></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Invoice date</label><input class="ims__input" type="date" id="ims-inv-date" value="${today}"></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Due date</label><input class="ims__input" type="date" id="ims-inv-due" value="${due}"></div>
        <div class="ims__form-group"><label class="ims__label">VAT rate (%)</label><input class="ims__input" type="number" step="0.01" id="ims-inv-vatrate" value="${vatRate}" oninput="window.IMS_ACCOUNTS.recalcInvoice()"></div>
        <div class="ims__form-group"><label class="ims__label">Account code</label><select class="ims__select" id="ims-inv-code">${codeOpts}</select></div>
      </div>
      <hr class="ims__divider">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px">
        <strong style="font-size:13px">Line items</strong>
        <button class="ims__btn ims__btn--secondary ims__btn--sm" onclick="window.IMS_ACCOUNTS.addInvoiceLine()"><i class="ti ti-plus"></i> Add line</button>
      </div>
      <div id="ims-inv-lines"></div>
      <hr class="ims__divider">
      <div style="display:flex;justify-content:flex-end;gap:20px;font-size:13px">
        <div style="text-align:right">
          <div>Net: <strong id="ims-inv-net">£0.00</strong></div>
          <div>VAT (<span id="ims-inv-vatpct">${vatRate}</span>%): <strong id="ims-inv-vat">£0.00</strong></div>
          <div style="font-size:16px;margin-top:4px">Total: <strong id="ims-inv-gross">£0.00</strong></div>
        </div>
      </div>
      <div class="ims__form-group" style="margin-top:12px"><label class="ims__label">Notes / payment terms</label><textarea class="ims__textarea" id="ims-inv-notes" rows="2">${util().sanitize(company?.invoice_terms||'')}</textarea></div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--secondary" onclick="window.IMS_ACCOUNTS.saveInvoice('draft')"><i class="ti ti-device-floppy"></i> Save draft</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_ACCOUNTS.saveInvoice('sent')"><i class="ti ti-send"></i> Save &amp; mark sent</button>
    `,'xl');

    // Start with one line
    _invLines=[{description:'',quantity:1,unit_price:0}];
    renderInvoiceLines();
  }

  let _invLines=[];

  function addInvoiceLine(){
    _invLines.push({description:'',quantity:1,unit_price:0});
    renderInvoiceLines();
  }

  function renderInvoiceLines(){
    const container=document.getElementById('ims-inv-lines');
    if(!container)return;
    container.innerHTML=_invLines.map((line,i)=>`
      <div style="display:grid;grid-template-columns:3fr 80px 120px auto;gap:8px;align-items:center;margin-bottom:8px">
        <input class="ims__input" type="text" placeholder="Description" value="${util().sanitize(line.description)}"
          oninput="window.IMS_ACCOUNTS.updateInvLine(${i},'description',this.value)">
        <input class="ims__input" type="number" min="0.001" step="0.001" placeholder="Qty" value="${line.quantity}"
          oninput="window.IMS_ACCOUNTS.updateInvLine(${i},'quantity',+this.value||1);window.IMS_ACCOUNTS.recalcInvoice()">
        <input class="ims__input" type="number" min="0" step="0.01" placeholder="Unit price (£ ex VAT)" value="${line.unit_price}"
          oninput="window.IMS_ACCOUNTS.updateInvLine(${i},'unit_price',+this.value||0);window.IMS_ACCOUNTS.recalcInvoice()">
        <button class="ims__btn ims__btn--danger ims__btn--sm ims__btn--icon" onclick="window.IMS_ACCOUNTS.removeInvLine(${i})"><i class="ti ti-trash"></i></button>
      </div>`).join('');
    recalcInvoice();
  }

  function updateInvLine(i,field,val){if(_invLines[i])_invLines[i][field]=val;}

  function removeInvLine(i){
    _invLines.splice(i,1);
    renderInvoiceLines();
  }

  function recalcInvoice(){
    const vatRate=parseFloat(document.getElementById('ims-inv-vatrate')?.value)||20;
    const net=_invLines.reduce((s,l)=>s+((l.quantity||1)*(l.unit_price||0)),0);
    const vat=util().netToVat(net,vatRate);
    const gross=util().netToGross(net,vatRate);
    const fmt=v=>`£${v.toFixed(2)}`;
    const set=(id,v)=>{const el=document.getElementById(id);if(el)el.textContent=v;};
    set('ims-inv-net',fmt(net));
    set('ims-inv-vat',fmt(vat));
    set('ims-inv-gross',fmt(gross));
    set('ims-inv-vatpct',vatRate);
  }

  async function saveInvoice(status){
    const g=id=>document.getElementById(id)?.value?.trim()||'';
    const custName=g('ims-inv-cust');
    if(!custName){ui().toast('Customer name is required','error');return;}
    if(!_invLines.length||_invLines.every(l=>!l.description)){ui().toast('Add at least one line item','error');return;}
    const vatRate=parseFloat(g('ims-inv-vatrate'))||20;
    const net=parseFloat(_invLines.reduce((s,l)=>s+((l.quantity||1)*(l.unit_price||0)),0).toFixed(2));
    const vatAmt=util().netToVat(net,vatRate);
    const gross=util().netToGross(net,vatRate);
    const company=window.SM.AUTH.company;
    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    const {data:lastInv}=await client.from('invoices').select('invoice_number').eq('company_id',company?.id).eq('invoice_type','sales').order('created_at',{ascending:false}).limit(1).maybeSingle();
    const invNum=g('ims-inv-num')||util().generateRef(company?.invoice_prefix||'INV',lastInv?.invoice_number);
    const {data:inv,error}=await client.from('invoices').insert({
      company_id:company?.id,invoice_number:invNum,invoice_type:'sales',
      customer_name:custName,customer_email:g('ims-inv-email')||null,
      customer_address:g('ims-inv-addr')||null,customer_vat_number:g('ims-inv-cvat')||null,
      invoice_date:g('ims-inv-date')||new Date().toISOString().split('T')[0],
      due_date:g('ims-inv-due'),
      net_amount:net,vat_rate:vatRate,vat_amount:vatAmt,gross_amount:gross,
      currency:'GBP',status,
      sent_at:status==='sent'?new Date().toISOString():null,
      notes:g('ims-inv-notes')||null,
      created_by:window.SM.AUTH.user?.id
    }).select().single();
    if(error){ui().toast('Failed: '+error.message,'error');return;}
    const codeId=document.getElementById('ims-inv-code')?.value||null;
    await Promise.all(_invLines.filter(l=>l.description).map((l,i)=>{
      const lNet=parseFloat(((l.quantity||1)*(l.unit_price||0)).toFixed(2));
      const lVat=util().netToVat(lNet,vatRate);
      const lGross=util().netToGross(lNet,vatRate);
      return client.from('invoice_lines').insert({
        invoice_id:inv.id,account_code_id:codeId||null,
        description:l.description,quantity:l.quantity||1,
        unit_price:l.unit_price||0,net_amount:lNet,
        vat_rate:vatRate,vat_amount:lVat,gross_amount:lGross,sort_order:i
      });
    }));
    ui().closeModal();
    ui().toast(`Invoice ${invNum} ${status==='draft'?'saved as draft':'created and marked sent'}`,'success');
    loadInvoices();
  }

  async function showGenerateFromOrder(){
    // Fetch delivered orders that don't yet have an invoice
    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    const {data:orders}=await client.from('orders')
      .select('id,order_number,customer_name,total_value,delivered_at,order_type')
      .eq('company_id',window.SM.AUTH.company?.id)
      .eq('status','delivered')
      .neq('fulfillment_type','dropship')
      .order('delivered_at',{ascending:false})
      .limit(50);

    // Filter out ones already invoiced
    const {data:existingInv}=await client.from('invoices').select('order_id').eq('company_id',window.SM.AUTH.company?.id).not('order_id','is',null);
    const invoicedOrderIds=new Set((existingInv||[]).map(i=>i.order_id));
    const uninvoiced=(orders||[]).filter(o=>!invoicedOrderIds.has(o.id));

    ui().openModal('Generate invoice from order',`
      <div class="ims__alert ims__alert--info" style="margin-bottom:14px">
        <i class="ti ti-info-circle"></i>
        <span>Select a delivered order to generate a VAT invoice. The order total is pre-filled but you can adjust before saving.</span>
      </div>
      <div class="ims__form-group">
        <label class="ims__label ims__label--req">Select order</label>
        <select class="ims__select" id="ims-gfi-order" onchange="window.IMS_ACCOUNTS.onGFIOrderChange()">
          <option value="">Select a delivered order...</option>
          ${uninvoiced.map(o=>`<option value="${o.id}" data-value="${o.total_value}" data-name="${util().sanitize(o.customer_name||'')}">${util().sanitize(o.order_number)} — ${util().sanitize(o.customer_name||'—')} — ${util().formatCurrency(o.total_value)}</option>`).join('')}
        </select>
      </div>
      <div id="ims-gfi-preview" style="margin-top:12px"></div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" id="ims-gfi-btn" style="display:none" onclick="window.IMS_ACCOUNTS.generateInvoiceFromOrder()"><i class="ti ti-file-plus"></i> Generate invoice</button>
    `,'sm');
  }

  function onGFIOrderChange(){
    const sel=document.getElementById('ims-gfi-order');
    const opt=sel?.options[sel?.selectedIndex];
    const preview=document.getElementById('ims-gfi-preview');
    const btn=document.getElementById('ims-gfi-btn');
    if(!sel?.value||!preview){if(btn)btn.style.display='none';return;}
    const gross=parseFloat(opt?.dataset?.value||0);
    const vatRate=window.SM.AUTH.company?.default_vat_rate||20;
    const net=util().grossToNet(gross,vatRate);
    const vat=util().netToVat(net,vatRate);
    preview.innerHTML=`
      <table class="ims__table">
        <tbody>
          <tr><td>Customer</td><td style="font-weight:600">${util().sanitize(opt?.dataset?.name||'—')}</td></tr>
          <tr><td>Net (ex VAT)</td><td>${util().formatCurrency(net)}</td></tr>
          <tr><td>VAT (${vatRate}%)</td><td>${util().formatCurrency(vat)}</td></tr>
          <tr><td style="font-weight:600">Gross total</td><td style="font-weight:700">${util().formatCurrency(gross)}</td></tr>
        </tbody>
      </table>`;
    if(btn)btn.style.display='';
  }

  async function generateInvoiceFromOrder(){
    const sel=document.getElementById('ims-gfi-order');
    const orderId=sel?.value;
    if(!orderId){ui().toast('Please select an order','error');return;}
    const opt=sel.options[sel.selectedIndex];
    const gross=parseFloat(opt?.dataset?.value||0);
    const custName=opt?.dataset?.name||'';
    const company=window.SM.AUTH.company;
    const vatRate=company?.default_vat_rate||20;
    const net=util().grossToNet(gross,vatRate);
    const vat=util().netToVat(net,vatRate);
    const payDays=company?.default_payment_days||14;
    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);

    // Fetch order details
    const {data:order}=await client.from('orders').select('*,order_items(product_name,sku,quantity,unit_price,total_price)').eq('id',orderId).maybeSingle();
    const {data:lastInv}=await client.from('invoices').select('invoice_number').eq('company_id',company?.id).eq('invoice_type','sales').order('created_at',{ascending:false}).limit(1).maybeSingle();
    const invNum=util().generateRef(company?.invoice_prefix||'INV',lastInv?.invoice_number);
    const today=new Date().toISOString().split('T')[0];
    const due=new Date(Date.now()+payDays*86400000).toISOString().split('T')[0];

    const {data:inv,error}=await client.from('invoices').insert({
      company_id:company?.id,invoice_number:invNum,invoice_type:'sales',
      order_id:orderId,customer_name:custName,
      customer_address:order?.address||null,customer_postcode:order?.postcode||null,
      customer_email:order?.email||null,
      invoice_date:today,due_date:due,
      net_amount:net,vat_rate:vatRate,vat_amount:vat,gross_amount:gross,
      currency:'GBP',status:'draft',
      notes:null,
      created_by:window.SM.AUTH.user?.id
    }).select().single();

    if(error){ui().toast('Failed: '+error.message,'error');return;}

    // Generate lines from order items
    const items=order?.order_items||[];
    if(items.length){
      await Promise.all(items.map((item,i)=>{
        const lNet=parseFloat((item.total_price||item.unit_price||0).toFixed(2));
        const lVat=util().netToVat(lNet,vatRate);
        const lGross=util().netToGross(lNet,vatRate);
        return client.from('invoice_lines').insert({
          invoice_id:inv.id,
          description:`${item.product_name||'—'}${item.sku?' ('+item.sku+')':''}`,
          quantity:item.quantity||1,unit_price:item.unit_price||0,
          net_amount:lNet,vat_rate:vatRate,vat_amount:lVat,gross_amount:lGross,sort_order:i
        });
      }));
    } else {
      // Single line for whole order
      await client.from('invoice_lines').insert({
        invoice_id:inv.id,description:'Goods supplied',
        quantity:1,unit_price:net,
        net_amount:net,vat_rate:vatRate,vat_amount:vat,gross_amount:gross,sort_order:0
      });
    }

    ui().closeModal();
    ui().toast(`Invoice ${invNum} generated from order`,'success');
    loadInvoices();
  }

  async function openInvoice(id){
    // Switched from a bare, freshly-created raw client to the shared,
    // already-authenticated db() wrapper. This query embeds
    // invoice_lines(*) — now that invoice_lines correctly has RLS
    // enabled, a raw client with no reliably-attached session can
    // silently fail this query entirely (returning nothing, no error
    // ever surfaced by this function), which is exactly what was
    // happening — not something specific to migrated data.
    // Two relationships now exist between invoices and orders:
    // invoices.order_id -> orders.id (this one, used for "generate from
    // a single order") and orders.invoice_id -> invoices.id (added in
    // the dropship migration, since one invoice can span many orders).
    // PostgREST can no longer auto-detect which to embed, so the
    // specific constraint name disambiguates it explicitly.
    const {data:inv,error}=await db().select('invoices',{
      select:'*,invoice_lines(*),orders!invoices_order_id_fkey(order_number)',
      eq:{id},maybeSingle:true,noCompanyFilter:true
    });
    if(error){ ui().toast('Failed to load invoice: '+error.message,'error',6000); console.error('[openInvoice]',error); return; }
    if(!inv){ ui().toast('Invoice not found','error'); return; }
    const lines=(inv.invoice_lines||[]).sort((a,b)=>a.sort_order-b.sort_order);
    ui().openModal(`Invoice: ${inv.invoice_number}`,`
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:14px">
        <div><span class="ims__label">Customer</span><div style="font-weight:600">${util().sanitize(inv.customer_name||'—')}</div></div>
        <div><span class="ims__label">Status</span><div>${util().pill(inv.status)}</div></div>
        <div><span class="ims__label">Invoice date</span><div>${util().formatDate(inv.invoice_date)}</div></div>
        <div><span class="ims__label">Due date</span><div style="color:${inv.status==='overdue'?'var(--ims-danger)':''}">${util().formatDate(inv.due_date)}</div></div>
        ${inv.orders?.order_number?`<div><span class="ims__label">Linked order</span><div>${util().sanitize(inv.orders.order_number)}</div></div>`:''}
        ${inv.customer_address?`<div style="grid-column:1/-1"><span class="ims__label">Address</span><div>${util().sanitize(inv.customer_address)}</div></div>`:''}
        ${inv.customer_vat_number?`<div><span class="ims__label">Customer VAT</span><div>${util().sanitize(inv.customer_vat_number)}</div></div>`:''}
        ${inv.paid_at?`<div><span class="ims__label">Paid</span><div style="color:var(--ims-success)">${util().formatDate(inv.paid_at)}</div></div>`:''}
      </div>
      <hr class="ims__divider">
      <div class="ims__table-wrap">
        <table class="ims__table">
          <thead><tr><th>Description</th><th style="text-align:right">Qty</th><th style="text-align:right">Unit price</th><th style="text-align:right">Net</th><th style="text-align:right">VAT</th><th style="text-align:right">Gross</th></tr></thead>
          <tbody>
            ${lines.map(l=>`<tr>
              <td>${util().sanitize(l.description)}</td>
              <td style="text-align:right">${l.quantity}</td>
              <td style="text-align:right">${util().formatCurrency(l.unit_price)}</td>
              <td style="text-align:right">${util().formatCurrency(l.net_amount)}</td>
              <td style="text-align:right;font-size:11px">${util().formatCurrency(l.vat_amount)}</td>
              <td style="text-align:right;font-weight:600">${util().formatCurrency(l.gross_amount)}</td>
            </tr>`).join('')}
            <tr style="border-top:2px solid var(--ims-border)">
              <td colspan="3" style="text-align:right;font-weight:600">Totals</td>
              <td style="text-align:right;font-weight:600">${util().formatCurrency(inv.net_amount)}</td>
              <td style="text-align:right;font-size:11px">${util().formatCurrency(inv.vat_amount)}</td>
              <td style="text-align:right;font-weight:700;font-size:15px">${util().formatCurrency(inv.gross_amount)}</td>
            </tr>
          </tbody>
        </table>
      </div>
      ${inv.notes?`<div style="margin-top:12px;font-size:12px;color:var(--ims-text-sec)">${util().sanitize(inv.notes)}</div>`:''}
    `,`
      <div class="ims__btn-group">
        <button class="ims__btn ims__btn--ghost" onclick="window.IMS_ACCOUNTS.printInvoice('${inv.id}')"><i class="ti ti-printer"></i> Print</button>
        ${inv.status==='draft'?`<button class="ims__btn ims__btn--info" onclick="window.IMS_ACCOUNTS.markInvoiceSent('${inv.id}')"><i class="ti ti-send"></i> Mark sent</button>`:''}
        ${['sent','overdue'].includes(inv.status)?`<button class="ims__btn ims__btn--success" onclick="window.IMS_ACCOUNTS.markInvoicePaid('${inv.id}',${inv.gross_amount})"><i class="ti ti-currency-pound"></i> Mark paid</button>`:''}
        ${['sent','overdue','paid'].includes(inv.status)?`<button class="ims__btn ims__btn--warning" onclick="window.IMS_ACCOUNTS.showNewNote('${inv.id}','${util().sanitize(inv.invoice_number)}')"><i class="ti ti-file-minus"></i> Issue note</button>`:''}
        ${window.SM.AUTH.isSuperAdmin()?`<button class="ims__btn ims__btn--danger" onclick="window.SM.UI.closeModal();window.IMS_ACCOUNTS.deleteInvoice('${inv.id}','${util().sanitize(inv.invoice_number)}')"><i class="ti ti-trash"></i> Delete invoice</button>`:''}
        <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Close</button>
      </div>
    `,'lg');
  }

  async function markInvoiceSent(id){
    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    await client.from('invoices').update({status:'sent',sent_at:new Date().toISOString()}).eq('id',id);
    ui().toast('Invoice marked as sent','success');
    ui().closeModal();
    loadInvoices();
  }

  async function markInvoicePaid(id,amount){
    ui().openModal('Mark invoice as paid',`
      <div class="ims__form-grid">
        <div class="ims__form-group"><label class="ims__label ims__label--req">Payment date</label><input class="ims__input" type="date" id="ims-invpay-date" value="${new Date().toISOString().split('T')[0]}"></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Amount received (£)</label><input class="ims__input" type="number" step="0.01" id="ims-invpay-amount" value="${amount.toFixed(2)}"></div>
        <div class="ims__form-group"><label class="ims__label">Payment method</label>
          <select class="ims__select" id="ims-invpay-method">
            <option value="bank_transfer">Bank transfer</option><option value="card">Card</option><option value="cash">Cash</option><option value="cheque">Cheque</option>
          </select></div>
        <div class="ims__form-group"><label class="ims__label">Reference</label><input class="ims__input" type="text" id="ims-invpay-ref"></div>
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--success" onclick="window.IMS_ACCOUNTS.confirmInvoicePaid('${id}',${amount})"><i class="ti ti-check"></i> Confirm payment</button>
    `,'sm');
  }

  async function confirmInvoicePaid(id,totalAmount){
    const paidAmt=parseFloat(document.getElementById('ims-invpay-amount')?.value)||0;
    const method=document.getElementById('ims-invpay-method')?.value;
    const ref=document.getElementById('ims-invpay-ref')?.value?.trim();
    const dateVal=document.getElementById('ims-invpay-date')?.value;
    if(!paidAmt){ui().toast('Enter amount received','error');return;}
    const isPartial=paidAmt<totalAmount;
    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    await client.from('invoices').update({
      status:isPartial?'partially_paid':'paid',
      paid_amount:paidAmt,paid_at:new Date().toISOString(),
      payment_method:method,payment_ref:ref||null
    }).eq('id',id);
    // Record in transactions
    const {data:inv}=await client.from('invoices').select('invoice_number,customer_name,net_amount,vat_amount').eq('id',id).maybeSingle();
    await db().insert('transactions',{
      date:dateVal,type:'income',category:'Sales revenue',
      description:`Payment received — ${inv?.invoice_number||'invoice'} — ${inv?.customer_name||''}`,
      amount:paidAmt,vat_amount:isPartial?0:inv?.vat_amount||0,
      reference:ref||inv?.invoice_number
    });
    ui().closeModal();
    ui().toast(`Payment of ${util().formatCurrency(paidAmt)} recorded${isPartial?' — partial':''}`, 'success');
    loadInvoices();
  }

  async function printInvoice(id){
    // Same fix as openInvoice() — bare raw client swapped for the
    // authenticated db() wrapper, since this identical query embeds
    // invoice_lines(*), which now correctly has RLS enabled.
    const {data:inv,error}=await db().select('invoices',{
      select:'*,invoice_lines(*),orders!invoices_order_id_fkey(order_number)',
      eq:{id},maybeSingle:true,noCompanyFilter:true
    });
    if(error){ ui().toast('Failed to load invoice: '+error.message,'error',6000); console.error('[printInvoice]',error); return; }
    if(!inv){ ui().toast('Invoice not found','error'); return; }
    const company=window.SM.AUTH.company;
    const lines=(inv.invoice_lines||[]).sort((a,b)=>a.sort_order-b.sort_order);

    window.PRINT.invoice({
      company:{
        name:company?.name, address:company?.address, postcode:company?.postcode,
        country:company?.country, vat_number:company?.vat_number,
        bank_name:company?.bank_name, bank_account:company?.bank_account, bank_sort_code:company?.bank_sort_code
      },
      invoiceNumber:inv.invoice_number,
      invoiceDate:util().formatDate(inv.invoice_date),
      orderNo:inv.orders?.order_number||'',
      accountRef:inv.account_ref||'',
      customer:{
        name:inv.customer_name, address:inv.customer_address, postcode:inv.customer_postcode,
        vatNumber:inv.customer_vat_number, eoriNo:inv.eori_no
      },
      lines:lines.map(l=>({
        productCode:l.product_code, description:l.description, quantity:l.quantity,
        hsTariffCode:l.hs_tariff_code, countryOfOrigin:l.country_of_origin,
        unitWeightKg:l.unit_weight_kg, unitPrice:l.unit_price, netAmount:l.net_amount
      })),
      netTotal:inv.net_amount,
      carriageAmount:inv.carriage_amount||0,
      vatAmount:inv.vat_amount,
      grossTotal:inv.gross_amount,
      totalPackages:inv.total_packages,
      totalNetWeightKg:lines.reduce((s,l)=>s+((l.unit_weight_kg||0)*(l.quantity||0)),0),
      incoterms:inv.incoterms
    });
  }

  // ─── DELETE INVOICE (Super Admin only) ──────────────────────────
  // Restricted to super_admin specifically (not the broader isAdmin()
  // check) since this permanently removes financial documents. If the
  // invoice was generated from a single order (order_id set — never
  // true for dropship invoices, which span multiple orders), any
  // accounts_receivable row tied to that same order is removed too,
  // since accounts_receivable has no direct invoice_id link at all —
  // it only ever references orders.order_id.
  async function deleteInvoice(id, invoiceNumber){
    if(!window.SM.AUTH.isSuperAdmin()){ui().toast('Only Super Admin can delete invoices','error');return;}
    ui().confirm(
      `Permanently delete invoice <strong>${util().sanitize(invoiceNumber)}</strong>?<br><br>This cannot be undone. If this invoice was generated from an order and has a matching receivable record, that will be removed too.`,
      async()=>{
        const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);

        const {data:inv}=await client.from('invoices').select('id,order_id').eq('id',id).maybeSingle();

        // Clear any orders pointing at this invoice first, to avoid the
        // orders_invoice_id_fkey foreign key blocking the delete below.
        await client.from('orders').update({invoice_id:null}).eq('invoice_id',id);

        // Remove the matching receivable, if this invoice traces back
        // to a single order (accounts_receivable has no invoice_id of
        // its own — order_id is the only real link available).
        if(inv?.order_id){
          await client.from('accounts_receivable').delete().eq('order_id',inv.order_id);
        }

        await client.from('invoice_lines').delete().eq('invoice_id',id);
        const {error}=await client.from('invoices').delete().eq('id',id);

        if(error){ui().toast('Failed to delete invoice: '+error.message,'error',6000);return;}
        ui().toast(`Invoice ${invoiceNumber} deleted`,'success');
        // Refresh both invoice views — Accounts' own list and Dropship's
        // (since the migration, both read the same shared invoices
        // table). Deleting via the eye-icon modal is often triggered
        // while the Dropship panel is the one actually visible on
        // screen, so only refreshing Accounts' hidden view left the
        // deleted row appearing to still be there until a full manual
        // page reload. Each is called defensively — harmless if that
        // panel isn't currently mounted.
        setTimeout(()=>{
          if(document.getElementById('ims-acc-content')) loadInvoices();
          if(window.IMS_DROPSHIP?.loadInvoices) window.IMS_DROPSHIP.loadInvoices();
        },150);
      },
      'Delete invoice', true
    );
  }

  // ─── CREDIT & DEBIT NOTES TAB ────────────────────────────────────
  async function loadNotes(){
    const content=document.getElementById('ims-acc-content');
    if(!content)return;
    content.innerHTML=`<div class="ims__loading"><i class="ti ti-loader-2 ims__spin"></i></div>`;
    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    const {data:notes}=await client.from('invoices')
      .select('*')
      .eq('company_id',window.SM.AUTH.company?.id)
      .in('invoice_type',['credit_note','debit_note'])
      .order('created_at',{ascending:false});
    const items=notes||[];
    content.innerHTML=`
      <div style="display:flex;justify-content:flex-end;margin-bottom:14px">
        <button class="ims__btn ims__btn--primary" onclick="window.IMS_ACCOUNTS.showNewNote()"><i class="ti ti-plus"></i> New credit / debit note</button>
      </div>
      <div class="ims__card">
        <div class="ims__table-wrap">
          <table class="ims__table">
            <thead><tr><th>Note #</th><th>Type</th><th>Customer</th><th>Linked invoice</th><th>Reason</th><th>Net</th><th>VAT</th><th>Gross</th><th>Date</th><th></th></tr></thead>
            <tbody>${items.map(n=>`<tr>
              <td><span class="ims__link" onclick="window.IMS_ACCOUNTS.printInvoice('${n.id}')">${util().sanitize(n.invoice_number)}</span></td>
              <td>${util().pill(n.invoice_type==='credit_note'?'sent':'info')}<span style="font-size:11px;margin-left:4px">${n.invoice_type==='credit_note'?'Credit':'Debit'}</span></td>
              <td>${util().sanitize(n.customer_name||'—')}</td>
              <td style="font-size:11px">${util().sanitize(n.linked_invoice_id?'Linked':'Standalone')}</td>
              <td style="font-size:11px;max-width:160px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap" title="${util().sanitize(n.reason||'')}">${util().sanitize(n.reason||'—')}</td>
              <td>${util().formatCurrency(n.net_amount)}</td>
              <td style="font-size:11px">${util().formatCurrency(n.vat_amount)}</td>
              <td style="font-weight:600;color:${n.invoice_type==='credit_note'?'var(--ims-danger)':'var(--ims-warning)'}">${n.invoice_type==='credit_note'?'−':'+'} ${util().formatCurrency(n.gross_amount)}</td>
              <td style="font-size:11px">${util().formatDate(n.created_at)}</td>
              <td><button class="ims__btn ims__btn--secondary ims__btn--sm ims__btn--icon" onclick="window.IMS_ACCOUNTS.printInvoice('${n.id}')" title="Print"><i class="ti ti-printer"></i></button></td>
            </tr>`).join('')||'<tr><td colspan="10" class="ims__table-empty">No credit or debit notes yet</td></tr>'}
            </tbody>
          </table>
        </div>
      </div>`;
  }

  async function showNewNote(linkedInvoiceId=null,linkedInvoiceNum=null){
    const company=window.SM.AUTH.company;
    const vatRate=company?.default_vat_rate||20;
    const today=new Date().toISOString().split('T')[0];
    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);

    // Get last CN and DN numbers
    const [{data:lastCN},{data:lastDN}]=await Promise.all([
      client.from('invoices').select('invoice_number').eq('company_id',company?.id).eq('invoice_type','credit_note').order('created_at',{ascending:false}).limit(1).maybeSingle(),
      client.from('invoices').select('invoice_number').eq('company_id',company?.id).eq('invoice_type','debit_note').order('created_at',{ascending:false}).limit(1).maybeSingle()
    ]);
    const nextCN=util().generateRef(company?.credit_note_prefix||'CN',lastCN?.invoice_number);
    const nextDN=util().generateRef(company?.debit_note_prefix||'DN',lastDN?.invoice_number);

    ui().openModal('New credit / debit note',`
      <div class="ims__form-grid">
        <div class="ims__form-group"><label class="ims__label ims__label--req">Note type</label>
          <select class="ims__select" id="ims-note-type" onchange="window.IMS_ACCOUNTS.onNoteTypeChange('${nextCN}','${nextDN}')">
            <option value="credit_note">Credit note (CN) — reduces what customer owes</option>
            <option value="debit_note">Debit note (DN) — increases what customer owes</option>
          </select></div>
        <div class="ims__form-group"><label class="ims__label">Reference number</label><input class="ims__input" type="text" id="ims-note-num" value="${nextCN}" readonly style="background:var(--ims-surface2)"></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Customer name</label><input class="ims__input" type="text" id="ims-note-cust" value="${linkedInvoiceNum?'':''}" placeholder="Customer or business name"></div>
        <div class="ims__form-group"><label class="ims__label">Date</label><input class="ims__input" type="date" id="ims-note-date" value="${today}"></div>
        ${linkedInvoiceId?`<div class="ims__form-group ims__form-group--full"><div class="ims__alert ims__alert--info" style="margin:0"><i class="ti ti-link"></i><span>Linked to invoice <strong>${linkedInvoiceNum}</strong></span></div></div>`:''}
        <div class="ims__form-group ims__form-group--full"><label class="ims__label ims__label--req">Reason</label>
          <input class="ims__input" type="text" id="ims-note-reason" placeholder="e.g. Damaged goods — partial refund agreed, pricing error, goodwill gesture, short delivery..."></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Net amount (£ ex VAT)</label>
          <input class="ims__input" type="number" step="0.01" min="0" id="ims-note-net" oninput="window.IMS_ACCOUNTS.recalcNote()"></div>
        <div class="ims__form-group"><label class="ims__label">VAT rate (%)</label>
          <input class="ims__input" type="number" step="0.01" id="ims-note-vatrate" value="${vatRate}" oninput="window.IMS_ACCOUNTS.recalcNote()"></div>
        <div class="ims__form-group"><label class="ims__label">VAT amount</label>
          <input class="ims__input" type="text" id="ims-note-vat" readonly style="background:var(--ims-surface2)" placeholder="Auto-calculated"></div>
        <div class="ims__form-group"><label class="ims__label">Gross total</label>
          <input class="ims__input" type="text" id="ims-note-gross" readonly style="background:var(--ims-surface2);font-weight:600" placeholder="Auto-calculated"></div>
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_ACCOUNTS.saveNote('${linkedInvoiceId||''}')"><i class="ti ti-check"></i> Create note</button>
    `,'lg');
  }

  function onNoteTypeChange(nextCN,nextDN){
    const type=document.getElementById('ims-note-type')?.value;
    const numEl=document.getElementById('ims-note-num');
    if(numEl)numEl.value=type==='credit_note'?nextCN:nextDN;
  }

  function recalcNote(){
    const net=parseFloat(document.getElementById('ims-note-net')?.value)||0;
    const vatRate=parseFloat(document.getElementById('ims-note-vatrate')?.value)||20;
    const vat=util().netToVat(net,vatRate);
    const gross=util().netToGross(net,vatRate);
    const vatEl=document.getElementById('ims-note-vat');
    const grossEl=document.getElementById('ims-note-gross');
    if(vatEl)vatEl.value=`£${vat.toFixed(2)}`;
    if(grossEl)grossEl.value=`£${gross.toFixed(2)}`;
  }

  async function saveNote(linkedInvoiceId){
    const g=id=>document.getElementById(id)?.value?.trim()||'';
    const type=g('ims-note-type');
    const custName=g('ims-note-cust');
    const reason=g('ims-note-reason');
    const net=parseFloat(g('ims-note-net'))||0;
    const vatRate=parseFloat(g('ims-note-vatrate'))||20;
    if(!custName){ui().toast('Customer name is required','error');return;}
    if(!reason){ui().toast('Reason is required','error');return;}
    if(!net||net<=0){ui().toast('Enter a valid amount','error');return;}
    const vat=util().netToVat(net,vatRate);
    const gross=util().netToGross(net,vatRate);
    const company=window.SM.AUTH.company;
    const noteNum=g('ims-note-num');
    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    const {data:note,error}=await client.from('invoices').insert({
      company_id:company?.id,invoice_number:noteNum,invoice_type:type,
      linked_invoice_id:linkedInvoiceId||null,
      customer_name:custName,
      invoice_date:g('ims-note-date')||new Date().toISOString().split('T')[0],
      due_date:g('ims-note-date')||new Date().toISOString().split('T')[0],
      net_amount:net,vat_rate:vatRate,vat_amount:vat,gross_amount:gross,
      currency:'GBP',status:'sent',reason,
      created_by:window.SM.AUTH.user?.id
    }).select().single();
    if(error){ui().toast('Failed: '+error.message,'error');return;}
    // Single line
    await client.from('invoice_lines').insert({
      invoice_id:note.id,description:reason,quantity:1,unit_price:net,
      net_amount:net,vat_rate:vatRate,vat_amount:vat,gross_amount:gross,sort_order:0
    });
    // Record transaction
    await db().insert('transactions',{
      date:g('ims-note-date')||new Date().toISOString().split('T')[0],
      type:type==='credit_note'?'expense':'income',
      category:type==='credit_note'?'Credit note issued':'Sales revenue',
      amount:gross,vat_amount:vat,
      description:`${type==='credit_note'?'Credit':'Debit'} note ${noteNum} — ${reason}`,
      reference:noteNum
    });
    ui().closeModal();
    ui().toast(`${type==='credit_note'?'Credit':'Debit'} note ${noteNum} created`,'success');
    loadNotes();
  }

  // ─── EXPORT TO ACCOUNTING SOFTWARE ──────────────────────────────
  async function showExport(){
    const now=new Date();
    const mStart=new Date(now.getFullYear(),now.getMonth(),1).toISOString().split('T')[0];
    const today=now.toISOString().split('T')[0];

    ui().openModal('Export to accounting software',`
      <div class="ims__alert ims__alert--info" style="margin-bottom:14px">
        <i class="ti ti-info-circle"></i>
        <span>Export invoices, credit/debit notes, and transactions in your accounting software's import format. Import the CSV directly into Xero or Sage.</span>
      </div>
      <div class="ims__form-grid">
        <div class="ims__form-group"><label class="ims__label ims__label--req">Date from</label><input class="ims__input" type="date" id="ims-exp-from" value="${mStart}"></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Date to</label><input class="ims__input" type="date" id="ims-exp-to" value="${today}"></div>
      </div>
      <div class="ims__form-group" style="margin-bottom:12px">
        <label class="ims__label">Include documents</label>
        <div style="display:flex;flex-direction:column;gap:6px;margin-top:4px">
          <label style="display:flex;align-items:center;gap:8px;font-size:13px"><input type="checkbox" id="ims-exp-inv" checked> Sales invoices (INV-)</label>
          <label style="display:flex;align-items:center;gap:8px;font-size:13px"><input type="checkbox" id="ims-exp-cn" checked> Credit notes (CN-)</label>
          <label style="display:flex;align-items:center;gap:8px;font-size:13px"><input type="checkbox" id="ims-exp-dn" checked> Debit notes (DN-)</label>
          <label style="display:flex;align-items:center;gap:8px;font-size:13px"><input type="checkbox" id="ims-exp-tx"> Transactions (bank feed)</label>
        </div>
      </div>
      <div class="ims__form-group">
        <label class="ims__label ims__label--req">Format</label>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:4px">
          <label style="display:flex;align-items:center;gap:8px;padding:10px 12px;border:1.5px solid var(--ims-border);border-radius:var(--ims-radius);cursor:pointer;font-size:13px">
            <input type="radio" name="ims-exp-fmt" value="xero" checked>
            <span><strong>Xero</strong><br><span style="font-size:11px;color:var(--ims-text-muted)">Xero invoice import CSV</span></span>
          </label>
          <label style="display:flex;align-items:center;gap:8px;padding:10px 12px;border:1.5px solid var(--ims-border);border-radius:var(--ims-radius);cursor:pointer;font-size:13px">
            <input type="radio" name="ims-exp-fmt" value="sage50">
            <span><strong>Sage 50</strong><br><span style="font-size:11px;color:var(--ims-text-muted)">Sage 50 audit trail</span></span>
          </label>
          <label style="display:flex;align-items:center;gap:8px;padding:10px 12px;border:1.5px solid var(--ims-border);border-radius:var(--ims-radius);cursor:pointer;font-size:13px">
            <input type="radio" name="ims-exp-fmt" value="sage_cloud">
            <span><strong>Sage Accounting</strong><br><span style="font-size:11px;color:var(--ims-text-muted)">Sage Business Cloud</span></span>
          </label>
          <label style="display:flex;align-items:center;gap:8px;padding:10px 12px;border:1.5px solid var(--ims-border);border-radius:var(--ims-radius);cursor:pointer;font-size:13px">
            <input type="radio" name="ims-exp-fmt" value="generic">
            <span><strong>Generic CSV</strong><br><span style="font-size:11px;color:var(--ims-text-muted)">For manual import / accountant</span></span>
          </label>
        </div>
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_ACCOUNTS.runExport()"><i class="ti ti-download"></i> Export CSV</button>
    `,'lg');
  }

  async function runExport(){
    const from=document.getElementById('ims-exp-from')?.value;
    const to=document.getElementById('ims-exp-to')?.value;
    const fmt=document.querySelector('input[name="ims-exp-fmt"]:checked')?.value||'generic';
    const inclInv=document.getElementById('ims-exp-inv')?.checked;
    const inclCN=document.getElementById('ims-exp-cn')?.checked;
    const inclDN=document.getElementById('ims-exp-dn')?.checked;
    const inclTx=document.getElementById('ims-exp-tx')?.checked;

    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);

    // Build invoice type filter
    const types=[];
    if(inclInv)types.push('sales');
    if(inclCN)types.push('credit_note');
    if(inclDN)types.push('debit_note');

    let invoices=[];
    if(types.length){
      const {data}=await client.from('invoices')
        .select('*,invoice_lines(*,account_codes(xero_code,sage50_code,sage_cloud_code,display_name))')
        .eq('company_id',window.SM.AUTH.company?.id)
        .in('invoice_type',types)
        .gte('invoice_date',from)
        .lte('invoice_date',to)
        .order('invoice_date');
      invoices=data||[];
    }

    let transactions=[];
    if(inclTx){
      const {data}=await db().select('transactions',{gte:{date:from},lte:{date:to},order:{col:'date',asc:true}});
      transactions=data||[];
    }

    if(!invoices.length&&!transactions.length){
      ui().toast('No data found for the selected period','warning');
      return;
    }

    const filename=`${fmt}_export_${from}_to_${to}`;

    switch(fmt){
      case 'xero':        exportXero(invoices,transactions,filename);       break;
      case 'sage50':      exportSage50(invoices,transactions,filename);     break;
      case 'sage_cloud':  exportSageCloud(invoices,transactions,filename);  break;
      default:            exportGeneric(invoices,transactions,filename);    break;
    }

    // Mark as exported
    if(invoices.length){
      const ids=invoices.map(i=>i.id);
      for(let i=0;i<ids.length;i+=50){
        await client.from('invoices').update({
          [`exported_${fmt==='sage50'?'sage50':fmt==='sage_cloud'?'sage_cloud':'xero'}`]:true,
          exported_at:new Date().toISOString()
        }).in('id',ids.slice(i,i+50));
      }
    }

    ui().closeModal();
    ui().toast(`Exported ${invoices.length} invoice(s)${transactions.length?' and '+transactions.length+' transaction(s)':''} as ${fmt.toUpperCase()} CSV`,'success');
  }

  function exportXero(invoices,transactions,filename){
    // Xero Sales Invoice / Credit Note import format
    const headers=['*ContactName','EmailAddress','*InvoiceNumber','*InvoiceDate','*DueDate','*Description','*Quantity','*UnitAmount','*AccountCode','*TaxType','TaxAmount','CurrencyCode','Reference','InvoiceType'];
    const rows=[];
    invoices.forEach(inv=>{
      const lines=(inv.invoice_lines||[]);
      const isCredit=inv.invoice_type==='credit_note';
      const invType=isCredit?'ACCRECCREDIT':'ACCRECINV';
      const taxType=inv.vat_rate===0?'EXEMPTEXPENSES':'OUTPUT2';
      lines.forEach(line=>{
        const code=line.account_codes?.xero_code||'200';
        rows.push([
          inv.customer_name||'',
          inv.customer_email||'',
          inv.invoice_number,
          inv.invoice_date,
          inv.due_date,
          line.description||'',
          isCredit?-(line.quantity||1):(line.quantity||1),
          (line.unit_price||0).toFixed(2),
          code,
          taxType,
          (line.vat_amount||0).toFixed(2),
          inv.currency||'GBP',
          inv.notes||'',
          invType
        ]);
      });
    });
    if(transactions.length){
      // Xero bank statement import (separate sheet concept — appended here)
      transactions.forEach(t=>{
        rows.push([
          t.description||t.category||'',
          '',t.reference||'','','',
          t.description||'',
          t.type==='income'?1:-1,
          (t.amount||0).toFixed(2),
          '','','',
          'GBP',t.reference||'',''
        ]);
      });
    }
    util().exportCSV(headers,rows,filename);
  }

  function exportSage50(invoices,transactions,filename){
    // Sage 50 audit trail import format
    const headers=['Type','Account Reference','Nominal Code','Date','Ref','Details','Net Amount','Tax Code','Tax Amount','Exchange Rate'];
    const rows=[];
    invoices.forEach(inv=>{
      const lines=inv.invoice_lines||[];
      const typeCode=inv.invoice_type==='sales'?'SI':inv.invoice_type==='credit_note'?'SC':'SI';
      lines.forEach(line=>{
        const nominal=line.account_codes?.sage50_code||'4000';
        const net=inv.invoice_type==='credit_note'?-(line.net_amount||0):(line.net_amount||0);
        const vat=inv.invoice_type==='credit_note'?-(line.vat_amount||0):(line.vat_amount||0);
        rows.push([
          typeCode,
          inv.customer_name||'',
          nominal,
          formatSageDate(inv.invoice_date),
          inv.invoice_number,
          line.description||'',
          net.toFixed(2),
          inv.vat_rate===0?'T0':'T1',
          vat.toFixed(2),
          '1.00'
        ]);
      });
    });
    transactions.forEach(t=>{
      rows.push([
        t.type==='income'?'BR':'BP',
        '',
        '',
        formatSageDate(t.date),
        t.reference||'',
        t.description||t.category||'',
        (t.amount||0).toFixed(2),
        t.vat_amount?'T1':'T0',
        (t.vat_amount||0).toFixed(2),
        '1.00'
      ]);
    });
    util().exportCSV(headers,rows,filename);
  }

  function exportSageCloud(invoices,transactions,filename){
    // Sage Business Cloud Accounting import format
    const headers=['ContactName','InvoiceDate','DueDate','InvoiceNumber','Reference','Description','Quantity','UnitPrice','AccountCode','TaxRate','Currency'];
    const rows=[];
    invoices.forEach(inv=>{
      const lines=inv.invoice_lines||[];
      lines.forEach(line=>{
        const code=line.account_codes?.sage_cloud_code||'4000';
        rows.push([
          inv.customer_name||'',
          inv.invoice_date,
          inv.due_date,
          inv.invoice_number,
          inv.notes||'',
          line.description||'',
          inv.invoice_type==='credit_note'?-(line.quantity||1):(line.quantity||1),
          (line.unit_price||0).toFixed(2),
          code,
          inv.vat_rate===0?'Zero Rated':'Standard 20%',
          inv.currency||'GBP'
        ]);
      });
    });
    transactions.forEach(t=>{
      rows.push([
        t.description||'',t.date,t.date,t.reference||'',t.reference||'',
        t.description||t.category||'',
        t.type==='income'?1:-1,
        (t.amount||0).toFixed(2),
        '','Standard 20%','GBP'
      ]);
    });
    util().exportCSV(headers,rows,filename);
  }

  function exportGeneric(invoices,transactions,filename){
    // Generic format — all fields, no software-specific constraints
    const headers=['Document type','Document number','Customer','Email','Invoice date','Due date','Description','Qty','Unit price (ex VAT)','Net amount','VAT rate %','VAT amount','Gross amount','Account code (Xero)','Account code (Sage 50)','Reason/notes','Currency','Status'];
    const rows=[];
    invoices.forEach(inv=>{
      const lines=inv.invoice_lines||[];
      lines.forEach(line=>{
        rows.push([
          inv.invoice_type==='sales'?'Sales Invoice':inv.invoice_type==='credit_note'?'Credit Note':'Debit Note',
          inv.invoice_number,inv.customer_name||'',inv.customer_email||'',
          inv.invoice_date,inv.due_date,line.description||'',
          line.quantity||1,(line.unit_price||0).toFixed(2),
          (line.net_amount||0).toFixed(2),inv.vat_rate||20,
          (line.vat_amount||0).toFixed(2),(line.gross_amount||0).toFixed(2),
          line.account_codes?.xero_code||'',line.account_codes?.sage50_code||'',
          inv.reason||inv.notes||'',inv.currency||'GBP',inv.status||''
        ]);
      });
    });
    transactions.forEach(t=>{
      rows.push([
        t.type==='income'?'Income':'Expense',
        t.reference||'','','',t.date,t.date,
        t.description||t.category||'',1,
        (t.amount||0).toFixed(2),(t.amount||0).toFixed(2),
        t.vat_amount?20:0,(t.vat_amount||0).toFixed(2),
        ((t.amount||0)+(t.vat_amount||0)).toFixed(2),
        '','',t.category||'','GBP',''
      ]);
    });
    util().exportCSV(headers,rows,filename);
  }

  function formatSageDate(dateStr){
    if(!dateStr)return '';
    try{
      const d=new Date(dateStr);
      return `${String(d.getDate()).padStart(2,'0')}/${String(d.getMonth()+1).padStart(2,'0')}/${d.getFullYear()}`;
    }catch(e){return dateStr;}
  }

  // ─── PAYABLES ───────────────────────────────────────────────────
  async function loadPayables(){
    const content=document.getElementById('ims-acc-content');
    if(!content)return;
    const {data:payables}=await db().select('accounts_payable',{
      select:'*, suppliers(name), purchase_orders(po_number)',
      order:{col:'created_at',asc:false}
    });
    const items=payables||[];
    const aging={a:0,b:0,c:0,d:0};
    items.filter(p=>p.status!=='paid').forEach(p=>{
      const days=util().daysSince(p.created_at);
      const outstanding=(p.amount||0)-(p.paid_amount||0);
      if(days<=30)aging.a+=outstanding;
      else if(days<=60)aging.b+=outstanding;
      else if(days<=90)aging.c+=outstanding;
      else aging.d+=outstanding;
    });
    content.innerHTML=`
      <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:10px;margin-bottom:14px">
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">0–30 days</div><div class="ims__stat-value" style="font-size:16px">${util().formatCurrency(aging.a)}</div></div>
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">31–60 days</div><div class="ims__stat-value ims__stat-value--${aging.b>0?'warning':''}" style="font-size:16px">${util().formatCurrency(aging.b)}</div></div>
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">61–90 days</div><div class="ims__stat-value ims__stat-value--${aging.c>0?'danger':''}" style="font-size:16px">${util().formatCurrency(aging.c)}</div></div>
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">90+ days</div><div class="ims__stat-value ims__stat-value--${aging.d>0?'danger':''}" style="font-size:16px">${util().formatCurrency(aging.d)}</div></div>
      </div>
      <div class="ims__card"><div class="ims__table-wrap">
        <table class="ims__table">
          <thead><tr><th>Supplier</th><th>Ref</th><th>PO</th><th>Amount</th><th>Paid</th><th>Outstanding</th><th>Age</th><th>Status</th><th></th></tr></thead>
          <tbody>${items.map(p=>{
            const outstanding=(p.amount||0)-(p.paid_amount||0);
            const days=util().daysSince(p.created_at);
            return `<tr>
              <td>${util().sanitize(p.suppliers?.name||'—')}</td><td>${util().sanitize(p.invoice_ref||'—')}</td><td>${util().sanitize(p.purchase_orders?.po_number||'—')}</td>
              <td>${util().formatCurrency(p.amount)}</td><td>${util().formatCurrency(p.paid_amount)}</td>
              <td style="font-weight:600;color:${outstanding>0?'var(--ims-warning)':''}">${util().formatCurrency(outstanding)}</td>
              <td style="color:${days>60?'var(--ims-danger)':days>30?'var(--ims-warning)':''}">${days}d</td>
              <td>${util().pill(p.status)}</td>
              <td>${p.status!=='paid'?`<button class="ims__btn ims__btn--primary ims__btn--sm" onclick="window.IMS_ACCOUNTS.recordPayment('payable','${p.id}',${outstanding})"><i class="ti ti-currency-pound"></i> Pay</button>`:''}</td>
            </tr>`;
          }).join('')||'<tr><td colspan="9" class="ims__table-empty">No payables</td></tr>'}
          </tbody>
        </table>
      </div></div>`;
  }

  // ─── RECEIVABLES ────────────────────────────────────────────────
  async function loadReceivables(){
    const content=document.getElementById('ims-acc-content');
    if(!content)return;
    const {data:receivables}=await db().select('accounts_receivable',{
      select:'*, customers(business_name), orders(order_number)',
      order:{col:'created_at',asc:false}
    });
    const items=receivables||[];
    const aging={a:0,b:0,c:0,d:0};
    items.filter(r=>r.status!=='paid').forEach(r=>{
      const days=util().daysSince(r.created_at);
      const outstanding=(r.amount||0)-(r.paid_amount||0);
      if(days<=30)aging.a+=outstanding;
      else if(days<=60)aging.b+=outstanding;
      else if(days<=90)aging.c+=outstanding;
      else aging.d+=outstanding;
    });
    content.innerHTML=`
      <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:10px;margin-bottom:14px">
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">0–30 days</div><div class="ims__stat-value" style="font-size:16px">${util().formatCurrency(aging.a)}</div></div>
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">31–60 days</div><div class="ims__stat-value ims__stat-value--${aging.b>0?'warning':''}" style="font-size:16px">${util().formatCurrency(aging.b)}</div></div>
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">61–90 days</div><div class="ims__stat-value ims__stat-value--${aging.c>0?'danger':''}" style="font-size:16px">${util().formatCurrency(aging.c)}</div></div>
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">90+ days</div><div class="ims__stat-value ims__stat-value--${aging.d>0?'danger':''}" style="font-size:16px">${util().formatCurrency(aging.d)}</div></div>
      </div>
      <div class="ims__card"><div class="ims__table-wrap">
        <table class="ims__table">
          <thead><tr><th>Customer</th><th>Ref</th><th>Order</th><th>Amount</th><th>Paid</th><th>Outstanding</th><th>Age</th><th>Status</th><th></th></tr></thead>
          <tbody>${items.map(r=>{
            const outstanding=(r.amount||0)-(r.paid_amount||0);
            const days=util().daysSince(r.created_at);
            return `<tr>
              <td>${util().sanitize(r.customers?.business_name||r.customer_name||'—')}</td><td>${util().sanitize(r.invoice_ref||'—')}</td><td>${util().sanitize(r.orders?.order_number||'—')}</td>
              <td>${util().formatCurrency(r.amount)}</td><td>${util().formatCurrency(r.paid_amount)}</td>
              <td style="font-weight:600;color:${outstanding>0?'var(--ims-accent)':''}">${util().formatCurrency(outstanding)}</td>
              <td style="color:${days>60?'var(--ims-danger)':days>30?'var(--ims-warning)':''}">${days}d</td>
              <td>${util().pill(r.status)}</td>
              <td>${r.status!=='paid'?`<button class="ims__btn ims__btn--primary ims__btn--sm" onclick="window.IMS_ACCOUNTS.recordPayment('receivable','${r.id}',${outstanding})"><i class="ti ti-currency-pound"></i> Receive</button>`:''}</td>
            </tr>`;
          }).join('')||'<tr><td colspan="9" class="ims__table-empty">No receivables</td></tr>'}
          </tbody>
        </table>
      </div></div>`;
  }

  async function recordPayment(type,id,outstanding){
    ui().openModal('Record payment',`
      <div class="ims__form-grid">
        <div class="ims__form-group"><label class="ims__label ims__label--req">Payment date</label><input class="ims__input" type="date" id="ims-pay-date" value="${new Date().toISOString().split('T')[0]}"></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Amount (£)</label><input class="ims__input" type="number" step="0.01" id="ims-pay-amount" value="${outstanding.toFixed(2)}"></div>
        <div class="ims__form-group ims__form-group--full"><label class="ims__label">Notes</label><input class="ims__input" type="text" id="ims-pay-notes" placeholder="Payment reference, bank transfer..."></div>
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_ACCOUNTS.confirmPayment('${type}','${id}',${outstanding})"><i class="ti ti-check"></i> Confirm</button>
    `,'sm');
  }

  async function confirmPayment(type,id,outstanding){
    const amount=parseFloat(document.getElementById('ims-pay-amount')?.value)||0;
    if(amount<=0){ui().toast('Please enter a valid amount','error');return;}
    const table=type==='payable'?'accounts_payable':'accounts_receivable';
    const {data:record}=await db().select(table,{eq:{id},maybeSingle:true,noCompanyFilter:true});
    if(!record){ui().toast('Record not found','error');return;}
    const newPaid=(record.paid_amount||0)+amount;
    const newStatus=newPaid>=(record.amount||0)?'paid':'partial';
    await db().update(table,id,{paid_amount:newPaid,status:newStatus,paid_at:newStatus==='paid'?new Date().toISOString():null});
    await db().insert('transactions',{date:new Date().toISOString().split('T')[0],type:type==='payable'?'expense':'income',category:type==='payable'?'Supplier payment':'Customer payment',amount,description:document.getElementById('ims-pay-notes')?.value||null,user_id:window.SM.AUTH.user?.id});
    ui().closeModal();ui().toast(`Payment of ${util().formatCurrency(amount)} recorded`,'success');
    type==='payable'?loadPayables():loadReceivables();
  }

  // ─── TRANSACTIONS ───────────────────────────────────────────────
  async function loadTransactions(){
    const content=document.getElementById('ims-acc-content');
    if(!content)return;
    const {data:txs}=await db().select('transactions',{order:{col:'date',asc:false},limit:100});
    const items=txs||[];
    content.innerHTML=`
      <div class="ims__filters" style="margin-bottom:14px">
        <div class="ims__search-wrap" style="max-width:300px"><i class="ti ti-search"></i><input class="ims__input" type="text" id="ims-tx-search" placeholder="Search..." oninput="window.IMS_ACCOUNTS.filterTransactions()"></div>
        <select class="ims__select" id="ims-tx-type-filter" onchange="window.IMS_ACCOUNTS.filterTransactions()">
          <option value="">All types</option><option value="income">Income</option><option value="expense">Expense</option>
        </select>
      </div>
      <div class="ims__card"><div class="ims__table-wrap">
        <table class="ims__table">
          <thead><tr><th>Date</th><th>Type</th><th>Category</th><th>Description</th><th>Amount</th><th>VAT</th><th>Ref</th></tr></thead>
          <tbody id="ims-tx-tbody">${renderTxRows(items)}</tbody>
        </table>
      </div></div>`;
    window._allTransactions=items;
  }

  function renderTxRows(items){
    return items.map(t=>`<tr>
      <td>${util().formatDate(t.date)}</td>
      <td><span class="ims__pill ims__pill--${t.type==='income'?'success':'warning'}">${t.type}</span></td>
      <td>${util().sanitize(t.category||'—')}</td>
      <td style="font-size:12px">${util().sanitize(t.description||'—')}</td>
      <td style="font-weight:600;color:${t.type==='income'?'var(--ims-success)':'var(--ims-danger)'}">${t.type==='expense'?'−':''}${util().formatCurrency(t.amount)}</td>
      <td>${t.vat_amount?util().formatCurrency(t.vat_amount):'—'}</td>
      <td style="font-size:12px">${util().sanitize(t.reference||'—')}</td>
    </tr>`).join('')||'<tr><td colspan="7" class="ims__table-empty">No transactions</td></tr>';
  }

  function filterTransactions(){
    const search=document.getElementById('ims-tx-search')?.value?.toLowerCase()||'';
    const typeF=document.getElementById('ims-tx-type-filter')?.value||'';
    const filtered=(window._allTransactions||[]).filter(t=>
      (!typeF||t.type===typeF)&&
      (!search||(t.category||'').toLowerCase().includes(search)||(t.description||'').toLowerCase().includes(search)||(t.reference||'').toLowerCase().includes(search))
    );
    const tbody=document.getElementById('ims-tx-tbody');
    if(tbody)tbody.innerHTML=renderTxRows(filtered);
  }

  // ─── CLAIMS ─────────────────────────────────────────────────────
  async function loadClaims(){
    const content=document.getElementById('ims-acc-content');
    if(!content)return;
    const {data:claims}=await db().select('claims',{
      select:'*, orders(order_number,customer_name), couriers(name)',
      order:{col:'raised_at',asc:false}
    });
    const items=claims||[];
    const rows=items.map(c=>{
      const days=util().daysSince(c.raised_at);
      const urgent=['escalated_14','overdue_30'].includes(c.status);
      const actionBtns=['settled','rejected'].includes(c.status)
        ?util().pill(c.status)
        :'<div class="ims__btn-group"><button class="ims__btn ims__btn--success ims__btn--sm" onclick="window.IMS_ACCOUNTS.settleClaim(\''+c.id+'\','+c.items_value+')"><i class="ti ti-check"></i> Settle</button><button class="ims__btn ims__btn--danger ims__btn--sm" onclick="window.IMS_ACCOUNTS.rejectClaim(\''+c.id+'\')"><i class="ti ti-x"></i> Reject</button></div>';
      return '<tr class="'+(urgent?'ims__row--delayed':'')+'"><td>'+util().sanitize(c.claim_reference||c.id.slice(0,8))+'</td><td>'+util().sanitize(c.orders?.order_number||'—')+'</td><td>'+util().sanitize(c.couriers?.name||'—')+'</td><td>'+util().formatCurrency(c.items_value)+'</td><td>'+util().formatDate(c.raised_at)+'</td><td style="color:'+(days>30?'var(--ims-danger)':days>14?'var(--ims-warning)':'')+';font-weight:600">'+days+'d</td><td>'+util().pill(c.status)+'</td><td>'+(c.settled_amount?util().formatCurrency(c.settled_amount):'—')+'</td><td>'+actionBtns+'</td></tr>';
    }).join('')||'<tr><td colspan="9" class="ims__table-empty">No claims</td></tr>';
    content.innerHTML='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px"><div class="ims__alert ims__alert--info" style="margin:0;flex:1;margin-right:12px"><i class="ti ti-info-circle"></i><span>Claims are raised when an order is marked <strong>Lost</strong> in Order Management, or manually here. Alerts fire at 14 and 30 days if unsettled.</span></div><button class="ims__btn ims__btn--primary ims__btn--sm" onclick="window.IMS_ACCOUNTS.showNewClaim()"><i class="ti ti-plus"></i> New claim</button></div><div class="ims__card"><div class="ims__table-wrap"><table class="ims__table"><thead><tr><th>Ref</th><th>Order</th><th>Courier</th><th>Claim value</th><th>Raised</th><th>Days open</th><th>Status</th><th>Settled</th><th></th></tr></thead><tbody>'+rows+'</tbody></table></div></div>';
  }

  async function settleClaim(claimId,claimValue){
    const amount=prompt('Settlement amount received (£):',claimValue.toFixed(2));
    if(amount===null)return;
    const settled=parseFloat(amount)||0;
    await db().update('claims',claimId,{status:'settled',settled_amount:settled,settled_at:new Date().toISOString()});
    if(settled>0){await db().insert('transactions',{date:new Date().toISOString().split('T')[0],type:'income',category:'Claim settlements',amount:settled,description:`Courier claim settled — ${claimId}`,user_id:window.SM.AUTH.user?.id});}
    const {data:notifs}=await db().select('notifications',{eq:{reference_id:claimId},noCompanyFilter:true});
    if(notifs?.length){const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);await client.from('notifications').update({is_read:true}).eq('reference_id',claimId);}
    ui().toast(`Claim settled for ${util().formatCurrency(settled)}`,'success');loadClaims();
  }

  async function rejectClaim(claimId){
    const reason=prompt('Reason for rejection:','Courier dispute rejected');
    if(reason===null)return;
    await db().update('claims',claimId,{status:'rejected',notes:reason});
    ui().toast('Claim marked as rejected','success');loadClaims();
  }

  async function showNewClaim(){
    const {data:couriers}=await db().select('couriers',{eq:{is_active:true},order:{col:'name'}});
    const {data:orders}=await db().select('orders',{select:'id,order_number,customer_name',in:{status:['dispatched','lost']},order:{col:'created_at',asc:false},limit:50});
    const courierOpts=(couriers||[]).map(c=>`<option value="${c.id}">${util().sanitize(c.name)}</option>`).join('');
    const orderOpts=(orders||[]).map(o=>`<option value="${o.id}">${util().sanitize(o.order_number)} — ${util().sanitize(o.customer_name||'')}</option>`).join('');
    ui().openModal('Raise new claim',`
      <div class="ims__form-grid">
        <div class="ims__form-group"><label class="ims__label ims__label--req">Courier</label><select class="ims__select" id="ims-nc-courier"><option value="">Select courier</option>${courierOpts}</select></div>
        <div class="ims__form-group"><label class="ims__label">Linked order (optional)</label><select class="ims__select" id="ims-nc-order"><option value="">No linked order</option>${orderOpts}</select></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Claim value (£)</label><input class="ims__input" type="number" step="0.01" min="0" id="ims-nc-value"></div>
        <div class="ims__form-group"><label class="ims__label">Claim reference</label><input class="ims__input" type="text" id="ims-nc-ref"></div>
        <div class="ims__form-group ims__form-group--full"><label class="ims__label ims__label--req">Description</label><textarea class="ims__textarea" id="ims-nc-desc" rows="3"></textarea></div>
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--danger" onclick="window.IMS_ACCOUNTS.saveNewClaim()"><i class="ti ti-file-alert"></i> Raise claim</button>
    `,'sm');
  }

  async function saveNewClaim(){
    const courierId=document.getElementById('ims-nc-courier')?.value;
    const orderId=document.getElementById('ims-nc-order')?.value;
    const value=parseFloat(document.getElementById('ims-nc-value')?.value)||0;
    const ref=document.getElementById('ims-nc-ref')?.value?.trim();
    const desc=document.getElementById('ims-nc-desc')?.value?.trim();
    if(!courierId){ui().toast('Please select a courier','error');return;}
    if(value<=0){ui().toast('Please enter a claim value','error');return;}
    if(!desc){ui().toast('Please enter a description','error');return;}
    const {error}=await db().insert('claims',{courier_id:courierId,order_id:orderId||null,claim_reference:ref||null,items_value:value,description:desc,status:'raised',raised_at:new Date().toISOString()});
    if(error){ui().toast('Failed: '+error.message,'error');return;}
    ui().closeModal();ui().toast(`Claim raised for ${util().formatCurrency(value)}`,'success');loadClaims();
  }

  // ─── VAT ────────────────────────────────────────────────────────
  async function loadVAT(){
    const content=document.getElementById('ims-acc-content');
    if(!content)return;
    const now=new Date();
    const qStart=new Date(now.getFullYear(),Math.floor(now.getMonth()/3)*3,1).toISOString().split('T')[0];
    const qEnd=new Date(now.getFullYear(),Math.floor(now.getMonth()/3)*3+3,0).toISOString().split('T')[0];
    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);

    const [{data:txs},{data:invLines}]=await Promise.all([
      db().select('transactions',{gte:{date:qStart},lte:{date:qEnd}}),
      client.from('invoice_lines').select('vat_amount,vat_rate,invoices(invoice_type,invoice_date,company_id)')
        .eq('invoices.company_id',window.SM.AUTH.company?.id)
        .gte('invoices.invoice_date',qStart)
        .lte('invoices.invoice_date',qEnd)
    ]);

    const txItems=txs||[];
    const txOutputVAT=txItems.filter(t=>t.type==='income').reduce((s,t)=>s+(t.vat_amount||0),0);
    const txInputVAT=txItems.filter(t=>t.type==='expense').reduce((s,t)=>s+(t.vat_amount||0),0);

    // Also include VAT from formal invoices
    const invOutputVAT=(invLines||[]).filter(l=>l.invoices?.invoice_type==='sales').reduce((s,l)=>s+(l.vat_amount||0),0);
    const cnVAT=(invLines||[]).filter(l=>l.invoices?.invoice_type==='credit_note').reduce((s,l)=>s+(l.vat_amount||0),0);

    const outputVAT=Math.max(txOutputVAT,invOutputVAT)-cnVAT;
    const inputVAT=txInputVAT;
    const netVAT=outputVAT-inputVAT;

    content.innerHTML=`
      <div class="ims__alert ims__alert--info"><i class="ti ti-info-circle"></i>
        <span>VAT quarter: <strong>${util().formatDate(qStart)} — ${util().formatDate(qEnd)}</strong>. Figures include both manual transactions and formal invoices.</span>
      </div>
      <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:16px">
        <div class="ims__stat"><div class="ims__stat-label">Output VAT (sales)</div><div class="ims__stat-value ims__stat-value--success">${util().formatCurrency(outputVAT)}</div></div>
        <div class="ims__stat"><div class="ims__stat-label">Input VAT (purchases)</div><div class="ims__stat-value ims__stat-value--warning">${util().formatCurrency(inputVAT)}</div></div>
        <div class="ims__stat"><div class="ims__stat-label">Net VAT liability</div><div class="ims__stat-value ims__stat-value--${netVAT>0?'danger':'success'}">${util().formatCurrency(Math.abs(netVAT))}</div><div class="ims__stat-sub">${netVAT>0?'Due to HMRC':'Refund owed'}</div></div>
      </div>
      <div class="ims__card">
        <div class="ims__card-header"><div class="ims__card-title">VAT return — MTD boxes</div>
          <button class="ims__btn ims__btn--secondary ims__btn--sm" onclick="window.IMS_ACCOUNTS.exportVATCSV('${qStart}','${qEnd}',${outputVAT},${inputVAT},${netVAT})"><i class="ti ti-download"></i> Export VAT summary</button>
        </div>
        <table class="ims__table"><tbody>
          <tr><td>Box 1: VAT due on sales</td><td style="text-align:right;font-weight:600">${util().formatCurrency(outputVAT)}</td></tr>
          <tr><td>Box 2: VAT due on acquisitions (EU)</td><td style="text-align:right">£0.00</td></tr>
          <tr><td>Box 3: Total VAT due (Box 1 + Box 2)</td><td style="text-align:right;font-weight:600">${util().formatCurrency(outputVAT)}</td></tr>
          <tr><td>Box 4: VAT reclaimed on purchases</td><td style="text-align:right;font-weight:600">${util().formatCurrency(inputVAT)}</td></tr>
          <tr style="border-top:2px solid var(--ims-border)"><td><strong>Box 5: Net VAT to pay/reclaim</strong></td><td style="text-align:right;font-weight:700;font-size:15px;color:${netVAT>0?'var(--ims-danger)':'var(--ims-success)'}">${util().formatCurrency(Math.abs(netVAT))} ${netVAT>0?'(payable)':'(refund)'}</td></tr>
          <tr style="border-top:1px solid var(--ims-border)"><td style="color:var(--ims-text-muted)">Box 6: Total value of sales (ex VAT)</td><td style="text-align:right;color:var(--ims-text-muted)">${util().formatCurrency(txItems.filter(t=>t.type==='income').reduce((s,t)=>s+(t.amount||0),0))}</td></tr>
          <tr><td style="color:var(--ims-text-muted)">Box 7: Total value of purchases (ex VAT)</td><td style="text-align:right;color:var(--ims-text-muted)">${util().formatCurrency(txItems.filter(t=>t.type==='expense').reduce((s,t)=>s+(t.amount||0),0))}</td></tr>
        </tbody></table>
      </div>`;
  }

  function exportVATCSV(from,to,outputVAT,inputVAT,netVAT){
    util().exportCSV(
      ['Box','Description','Amount (£)'],
      [
        ['Box 1','VAT due on sales',outputVAT.toFixed(2)],
        ['Box 2','VAT due on acquisitions (EU)','0.00'],
        ['Box 3','Total VAT due',outputVAT.toFixed(2)],
        ['Box 4','VAT reclaimed on purchases',inputVAT.toFixed(2)],
        ['Box 5','Net VAT to pay/reclaim',Math.abs(netVAT).toFixed(2)],
        ['','netVAT>0 = payable, netVAT<0 = refund',''],
        ['Period from',from,''],
        ['Period to',to,'']
      ],
      `vat_return_${from}_to_${to}`
    );
  }

  // ─── EVENTS ─────────────────────────────────────────────────────
  window.addEventListener('ims:panel',e=>{
    if(e.detail.panel==='accounts'){initTabs();loadOverview();}
  });
  window.addEventListener('ims:ready',()=>{
    document.getElementById('ims-acc-new-btn')?.addEventListener('click',showNewTransaction);
  });

  window.IMS_ACCOUNTS={
    load:loadOverview,loadTab,switchTab,
    loadOverview,loadInvoices,loadNotes,loadPayables,loadReceivables,loadTransactions,loadClaims,loadVAT,
    showNewTransaction,onTxTypeChange,saveTransaction,
    showNewInvoice,showGenerateFromOrder,onGFIOrderChange,generateInvoiceFromOrder,
    addInvoiceLine,updateInvLine,removeInvLine,recalcInvoice,saveInvoice,
    openInvoice,markInvoiceSent,markInvoicePaid,confirmInvoicePaid,printInvoice,deleteInvoice,
    showNewNote,onNoteTypeChange,recalcNote,saveNote,
    showExport,runExport,
    recordPayment,confirmPayment,settleClaim,rejectClaim,showNewClaim,saveNewClaim,
    exportVATCSV,filterTransactions
  };
})();